import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-m',
  templateUrl: './m.component.html',
  styleUrls: ['./m.component.scss']
})
export class MComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
